import {
  AUTOMOTIVE_SERVICES_CATEGORIES,
  CARS_VEHICLES_CATEGORIES,
  CATEGORIES,
  isAnyCarsVehiclesCategory,
  VEHICLES_PART_ACCESSORIES_CATEGORIES,
} from '@kijiji/category'

/**
 * It should be available for all PV (Power Vehicles) & NPV (Non-Power Vehicles)
 * */
const CATEGORIES_TO_EXCLUDE = [
  ...VEHICLES_PART_ACCESSORIES_CATEGORIES,
  ...AUTOMOTIVE_SERVICES_CATEGORIES,
  CATEGORIES.POWERBOATS_MOTORBOATS_CATEGORY_ID,
  CATEGORIES.CANOES_KAYAKS_PADDLE_CATEGORY_ID,
  CATEGORIES.SAILBOATS_CATEGORY_ID,
  CATEGORIES.TRAVEL_TRAILERS_CAMPERS_CATEGORY_ID,
  CATEGORIES.RVS_MOTORHOMES_CATEGORY_ID,
  CATEGORIES.PARK_MODELS_CATEGORY_ID,
  CARS_VEHICLES_CATEGORIES.OTHER,
]

/**
 * Defines if the payment estimator should be displayed
 * Depends on category and profile type
 *
 * @param categoryId - Category of listing to display calculator
 * @param isDealer - If the seller of the listing is a dealer
 */
export const isPaymentEstimatorAvailable = (categoryId: number, isDealer?: boolean) => {
  return (
    isAnyCarsVehiclesCategory(categoryId) && !CATEGORIES_TO_EXCLUDE.includes(categoryId) && isDealer
  )
}
